// extracted by mini-css-extract-plugin
export var attachButton = "_li-8";
export var sendButton = "_li-2";
export var sendDisabled = "_li-4";
export var sendEnabled = "_li-3";
export var sendIcon = "_li-6";
export var sendIconDisabled = "_li-7";
export var sendStreaming = "_li-5";
export var textarea = "_li-1";
export var wrapper = "_li-0";